/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Pro_DescInputs */

const en_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to land your dream job.`)
};

const de_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles, was du brauchst, um deinen Traumjob zu landen.`)
};

const fr_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce dont tu as besoin pour décrocher l'emploi de tes rêves.`)
};

const es_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que necesita para conseguir su empleo soñado.`)
};

const it_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto ciò di cui hai bisogno per ottenere il lavoro dei tuoi sogni.`)
};

const nl_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles wat je nodig hebt om je droombaan te krijgen.`)
};

const pl_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko, czego potrzebujesz, aby dostać pracę marzeń.`)
};

const fi_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki mitä tarvitset unelmatyöhön.`)
};

const da_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alt hvad du har brug for at få dit drømmejob.`)
};

const sv_pricing_plan_pro_desc = /** @type {(inputs: Pricing_Plan_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allt du behöver för att få ditt drömjobb.`)
};

/**
* | output |
* | --- |
* | "Everything you need to land your dream job." |
*
* @param {Pricing_Plan_Pro_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_pro_desc = /** @type {((inputs?: Pricing_Plan_Pro_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Pro_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_pro_desc(inputs)
	if (locale === "fr") return fr_pricing_plan_pro_desc(inputs)
	if (locale === "es") return es_pricing_plan_pro_desc(inputs)
	if (locale === "it") return it_pricing_plan_pro_desc(inputs)
	if (locale === "nl") return nl_pricing_plan_pro_desc(inputs)
	if (locale === "pl") return pl_pricing_plan_pro_desc(inputs)
	if (locale === "fi") return fi_pricing_plan_pro_desc(inputs)
	if (locale === "da") return da_pricing_plan_pro_desc(inputs)
	if (locale === "sv") return sv_pricing_plan_pro_desc(inputs)
	return en_pricing_plan_pro_desc(inputs)
});